module.exports = __webpack_public_path__ + "img/checkhouse.d721ea50.png";